module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.9463/images/left-arrow-circle.svg"